export default __webpack_public_path__ + "static/media/grafema_gim-tonico_11.e3681416.jpg";